@if (page$ | async; as page) {
  <div class="main">
    @if (filter$ | async; as filter) {
        <div class="filter-toolbar">
          <redispatch-planwert-filter
            [initialFilter]="filter"
            (filter)="filterChanged($event)"
          ></redispatch-planwert-filter>
        </div>
        @if (planwertPage$ | async; as planwertPage) {
          <div data-qa="planwerte-result">
            <redispatch-planwert-table [planwerte]="planwertPage.content"
              [netzbetreiberType]="profile.netzbetreiberType"
              [sortActive]="page.sort"
              [sortDirection]="page.direction"
              (sortChange)="sortChange($event)"
              >
            </redispatch-planwert-table>
            <mat-paginator #paginator
              [showFirstLastButtons]="false"
              [hidePageSize]="true"
              [pageSize]="PAGE_SIZE"
              [pageIndex]="page.page"
              [length]="planwertPage.totalElements"
              (page)="pageChange($event)"
              >
            </mat-paginator>
          </div>
        }
    }
  </div>
}
